var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-514ab153.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-d8694455.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "m3.307 3.307 25.385 25.385a8.152 8.152 0 0 1-3.035 2.078C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.318.863-8.109 0 0 .524-2.505 2.441-4.568Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M24.66 12.27c-.013.074-.04.125-.091.125-.187 0-.936-.557-1.005-.47-.068.087.273.817.205.852-.068.035-.29-.191-.29 0 0 .192.715 1.01.8 1.149-.067.086-.153-.035-.34-.018-.051.14.766 1.166.698 1.183-.068.018-.426-.156-.528-.174.017.14.239.4.34.696-1.532-.47-2.315-1.496-2.587-1.757-.136 0 .034.418-.068.418-.102 0-.545-.383-.784-.644-.085-.018.052.382-.05.574-.086 0-.886-.679-1.414-1.27-.527-.592-.425-1.705-.476-1.6-.052.104-.528.765-.716.904-.068 0 .103-.783-.05-.713-.154.07-.63.626-.784.73-.085-.052.17-.696 0-.626-.17.07-.68.678-.766.661-.12-.191.102-.487.068-.644-.204.087-.51.505-.579.435-.05-.208.102-.348.051-.487-.187.018-.732.505-.783.435-.051-.07.153-.313.136-.522-.17.104-.63.696-.647.54-.017-.157.75-1.619.988-1.897s.817-1.096 1.634-1.079c.817.018 1.5.781 1.788.4.409-.539 0 0 0 0 .409-.539-.868-.922-1.005-1.009-.136-.086-.153-.226-.34-.33-.187-.104-1.022-.418-.97-.47.05-.052.85.122 1.055.105.204-.018.75-.227.988-.157s.272.191.442.365c.17.174.681.522.903.522.221 0 .306-.33.374-.66.068-.331-.34-1.114.188-2.089.527-.974 1.958-1.844 2.06-1.74.102.105-.426.853-.34.87.135-.034.272-.07.306-.017.042.122-.205.54-.137.487.069-.052.35-.026.375.052.034.14-.349.461-.324.592.103.035.29-.018.392.122-.017.156-.443.365-.425.435.017.07.28.2.272.26-.026.236-.8.784-.715.853 1.464-.905 3.099 0 2.98-.017-.069.017-.767.295-.545.295.22 0 1.532 1.08 1.413 1.08-.12 0-.528.086-.307.086.221 0 1.26 1.653 1.158 1.618-.102-.035-.409-.174-.255-.07.153.105.664 1.584.51 1.532-.153-.053-.766-.644-.715-.453.051.192.273.627.085.557-.187-.07-.408-.4-.323-.14.085.262.647.505.766 2.245l.007.13c.422.642.717 1.344.717 2.045 0 2.61-2.452 2.714-3.099 2.157.58.07 2.588.14 2.588-2.157 0-.44-.101-.865-.268-1.268-.232 1.088-1.052 1.577-1.75 1.773-.868.243-1.668-.435-1.753-.575 1.498.557 2.52-.121 3.03-1.391a2.73 2.73 0 0 0 .097-.525c-.653-1.037-1.642-1.861-2.184-2.313.542.452 0 0 0 0Zm.34-.048c-.001-.114 0-.208.03-.22.079-.031.666.329.793.329s.11-.266.158-.235c.036.024.845.82 1.019 1.904a10.388 10.388 0 0 0-2-1.778c.432.287 0 0 0 0Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m12 17 .449 1.548H14l-1.225.947.45 1.505L12 20.054l-1.225.903.45-1.462L10 18.548h1.51L12 17Zm-4 7 .449 1.548H10l-1.225.947.45 1.505L8 27.054l-1.224.903.448-1.462L6 25.548h1.51L8 24Zm2-2 .225.774H11l-.612.473.224.753-.612-.473-.612.451.224-.73L9 22.773h.755L10 22ZM8 12l.449 1.548H10l-1.225.947.45 1.505L8 15.054l-1.224.903.448-1.462L6 13.548h1.51L8 12Zm-4 5 .449 1.548H6l-1.225.947.45 1.505L4 20.054l-1.224.903.448-1.462L2 18.548h1.51L4 17Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagPng = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagPng_default = SvgFlagPng;
export {
  FlagPng_default as default
};
